module.exports = __webpack_public_path__ + "static/media/empty-cart-illustration.fedfed1d.svg";